

import LessonWrapper from './components/lesson/LessonWrapper.vue';
import LessonCategory from './components/lesson/LessonCategory.vue';
import LessonMovie from './components/lesson/LessonMovie.vue';
import LessonReview from './components/lesson/LessonReview.vue';
import LessonQuiz from './components/lesson/LessonQuiz.vue';
import LessonExam from './components/lesson/LessonExam.vue';
import LessonExplanation from './components/lesson/LessonExplanation.vue';



export default [
  {
    path: '/apps',
    name: 'apps',
    redirect: {
      name: 'lesson'
    }
  },
  {
    path: '/apps/lesson',
    component: LessonWrapper,
    children: [
      {
        path: ':lesson_id/movie/:content_order',
        name: 'lesson.movie',
        component: LessonMovie,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/quiz/:content_order',
        name: 'lesson.quiz',
        component: LessonQuiz,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/review',
        name: 'lesson.review',
        component: LessonReview,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/exam',
        name: 'lesson.exam',
        component: LessonExam,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/explanation/:step',
        name: 'lesson.explanation',
        component: LessonExplanation,
        meta: {requiresAuth: true},
        props: true
      }
    ]
  }
];